import React, { useState } from 'react';

import { session } from '../../../services/session';
import { api } from '../../../services/api';
import { titleCase } from '../common/utils';
import ModalWrapper from '../modals/modal-wrapper';

import './developer-options-modal.scss';

const DeveloperOptionsModal = ({ setShowModal, showModal, apiId, getApiKeys }) => {
  const questionMark = ['disable', 'enable', 'delete'].includes(showModal) ? '?' : '';

  const [name, setName] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');

  function handleSubmit() {
    const handlerMap = {
      create: createApiKey,
      rename: renameApiKey,
      disable: disableApiKey,
      enable: enableApiKey,
      delete: deleteApiKey,
    };

    if (apiKey) {
      setShowModal(null);
    } else {
      handlerMap[showModal]();
    }
  }

  function createApiKey() {
    api
      .post(`/api/v0/users/${session.userId}/api_keys/`, { description: name })
      .then(res => {
        getApiKeys();
        setApiKey(res.data.data[0].access_token);
      })
      .catch(e => displayError(e));
  }

  function renameApiKey() {
    const params = { description: name };
    api
      .put(`/api/v0/users/${session.userId}/api_keys/${apiId}/`, params)
      .then(res => {
        getApiKeys();
        setShowModal(null);
      })
      .catch(e => displayError(e));
  }

  function disableApiKey() {
    const params = { is_enabled_by_user: false };
    api
      .put(`/api/v0/users/${session.userId}/api_keys/${apiId}/`, params)
      .then(res => {
        getApiKeys();
        setShowModal(null);
      })
      .catch(e => displayError(e));
  }

  function enableApiKey() {
    const params = { is_enabled_by_user: true };
    api
      .put(`/api/v0/users/${session.userId}/api_keys/${apiId}/`, params)
      .then(res => {
        getApiKeys();
        setShowModal(null);
      })
      .catch(e => displayError(e));
  }

  function deleteApiKey() {
    api
      .delete(`/api/v0/users/${session.userId}/api_keys/${apiId}/`)
      .then(res => {
        getApiKeys();
        setShowModal(null);
      })
      .catch(e => displayError(e));
  }

  function displayError(e) {
    if (e && e.message) setError(e.message);
  }

  const apiInfo = apiKey ? (
    <div className="key">{apiKey}</div>
  ) : ['rename', 'create'].includes(showModal) ? (
    <input value={name} onChange={e => setName(e.target.value)} placeholder="Enter API key name" />
  ) : null;

  const message = apiKey ? (
    `This is the only time you will be able to view your API key. Copy down this information and
			store it in a secure place. Do not close this window until you have copied down your key.`
  ) : showModal === 'create' ? (
    <>
      <span>Warning: </span>
      <span>This API key grants administrator privileges; do not share this with customers.</span>
    </>
  ) : null;

  const errorItem = error ? <div className="error">{error}</div> : null;

  return (
    <div className={`developer-options-modal ${showModal}`}>
      <ModalWrapper closeModal={() => setShowModal(null)}>
        <h1>
          {`${titleCase(showModal)}`} API Key{questionMark}
        </h1>
        {errorItem}
        <div className="api-info">{apiInfo}</div>
        <div className="message">{message}</div>
        <div className="btns">
          <button className="cancel" onClick={() => setShowModal(null)}>
            Cancel
          </button>
          <button className="submit" onClick={handleSubmit}>
            {`${apiKey ? 'Done' : titleCase(showModal)}`}
          </button>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default DeveloperOptionsModal;
